function fireGaEvent(name, params) {
  if (typeof gtag === "function") {
    gtag('event', name, params); // eslint-disable-line no-undef
  }
}

export default fireGaEvent;
